export const common = {
  // Navigation
  home: "HOME",
  narrative: "NARRATIVE", 
  commercial: "COMMERCIAL / MUSIC VIDEOS",
  doc: "DOC",
  reel: "REEL",
  bio: "BIO",
  contact: "CONTACT",
  
  // Header
  cinematographer: "CINEMATOGRAPHER & GIMBAL OPERATOR",
  
  // Footer
  allRightsReserved: "All rights reserved",
  
  // Contact
  getInTouch: "GET IN TOUCH",
  name: "Name",
  email: "Email", 
  message: "Message",
  send: "SEND",
  
  // Language
  language: "Language",
  english: "English",
  portuguese: "Português",
  
  // Doc page
  docDescription: "Capturing authentic stories and real moments through documentary cinematography. Each project represents a commitment to truthful storytelling and visual excellence.",
  
  // Project titles
  evidenciasDoAmor: "TRACES OF LOVE",
  benzinho: "LOVELLING",
  aWolfAmongSwans: "A WOLF AMONG SWANS",
  techBrandCampaign: "HOPEFULS",
  osUltimosDiasDeGilda: "THE LAST DAYS OF GILDA",
  
  // Project descriptions
  benzinhoDesc: "Feature Film / Fiction\nDirected by Gustavo Pizzi",
  evidenciasDoAmorDesc: "Feature Film / Fiction\nDirected by Pedro Antônio Paes",
  aWolfAmongSwansDesc: "Feature Film / Fiction\nDirected by Helena Varvaki and Marcos Schechtman",
  agentesMuitoEspeciaisDesc: "Feature Film / Directed by Pedro Antônio Paes and Zaga Marteletto",
  mallandroDesc: "Feature Film / Fiction\nDirected by Marco Antônio de Carvalho",
  doceFamiliaDesc: "Feature Film / Fiction\nDirected by Carol Durão",
  hopefulsDesc: "Feature Film / Fiction  Directed by Ives Rosenfeld",
  osUltimosDiasDeGildaDesc: "Mini Series / Fiction\nDirected by Gustavo Pizzi",
  jorgeOfCapadociaDesc: "Feature Film / Fiction\nDirected by Alexandre Machafer",
  esseAmorQueNosConsomeDesc: "Feature Film / Fiction/Doc  Directed By Allan Ribeiro",
  rensgaHitsDesc: "Series / Fiction  Directed by Carol Durão, Bella Gabaglia and Natalia Warth",
  fernandoDesc: "Feature Film / Doc/Fiction  Directed by Paula Vilela, Juaar and Igor Angelkort",
  xandAviaoDesc: "Music Video / Directed by Rodrigo Van der Put and Bruno Duarte",
  biltreDesc: "Music Video / Directed by Anna Costa",
  juanMarcusDesc: "Music Video / Directed by Rodrigo Van der Put and Bruno Duarte",
  leoSantanaDesc: "Music Video / Directed by Rodrigo Van der Put and Bruno Duarte",
  porUmRespiroDesc: "Series / Doc  Directed by Susanna Lira and Helena de Castro",
  nosDocumentaristasDesc: "Series / Doc / Directed by Susanna Lira",
  damasDoSambaDesc: "Feature Film / Doc  Directed by Susanna Lira",
  faustoFawcettDesc: "Feature Film / Doc\nDirected by Vitor Lopes",
  perfectStormDesc: "Feature Film / Doc  Directed by Gustavo Malheiros",
  outrosTemposDesc: "Series / Doc  Directed by Susanna Lira",
  
  // Bio content
  bioContent: `Pedro Faerstein is a brazilian cinematographer and gimbal operator with over two decades of experience in audiovisual production. 

Over the years, Pedro has accumulated a diverse portfolio, working as director of photography on short and feature films, documentaries, television fiction, commercials, music videos and institutional projects. Among his works, the following feature films stand out:

* "Positivas" (Susanna Lira, 2009)
* "Esse Amor que nos Consome" (Allan Ribeiro, 2012)
* "Damas do Samba" (Susanna Lira, 2013)
* "Aspirantes" (Ives Rosenfeld, 2015)
* "Fernando" (Igor Angelkorte, Paula Vilela e Ju Ariani, 2016)
* "Benzinho" (Gustavo Pizzi, 2016)
* "Jorge da Capadócia" (Alexandre Machafer, 2019)
* "Tempestade Perfeita" (Gustavo Malheiros, 2021)
* "Fausto Fawcett na Cabeça" (Vitor Lopes, 2021)
* "Doce Familia" (Carol Durão, 2022)
* "Mallandro, o Errado que deu Certo" (Marco Antônio de Carvalho, 2022)
* "Um Lobo entre Cisnes" (Marcos Schettmann e Helena Varvaki, 2023)
* "Evidências do Amor" (Pedro Antônio Paes, 2023)
* "Gambiarra, Uga Uga Show" (Gustavo Colombo, 2024)
* "Papai em apuros" (Carol Durão, 2024)
* "Agentes Muito Especiais" (Pedro Antônio Paes, 2024)

For TV, he has worked as director of photography on several series, such as:

* "Em busca do Pai" (GNT, 2012)
* "Meus Dias de Rock" (Canal Brasil, 2013)
* "Anônimos Famosos" (Cine Brasil TV, 2014)
* "Outros Tempos" (HBO, 2016)
* "Prêmio Multishow de Humor" (2016)
* "Que Marravilha" (GNT, 2017)
* "Os Últimos Dias de Gilda" (Gustavo Pizzi, Canal Brasil, 2018)
* "SuperBonita" (GNT, 2019)
* "Por um Respiro" (Globoplay, 2020)
* "O tempo que a gente tem" (GNT, 2021)
* "Rensga Hits" (Globoplay, 2ª e 3ª Temporada, 2024)
* "Marilia Mendonça" (Amazon Prime, 2025)
* "12 Signos de Valentina"(Netflix, 2026)`
};

export default common;
